import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "transparent",
  stroke: "#000",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"inherit\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#book-flip-page_svg__a)\"><path d=\"M15 3.95a25.5 25.5 0 0 1 3.942-.325c.113 0 .223.04.308.117.08.08.125.187.125.3v13.125a.425.425 0 0 1-.417.416c-6.908.1-8.958 2.292-8.958 2.292m0 0V5.9S7.958 3.717 1.058 3.625a.46.46 0 0 0-.308.117.43.43 0 0 0-.125.3v13.125a.425.425 0 0 0 .417.416c6.908.1 8.958 2.292 8.958 2.292\"></path><path d=\"M10 19.467a5 5 0 0 1 1.367-2.875A6.8 6.8 0 0 1 15 14.542V1.533a.38.38 0 0 0-.192-.333.5.5 0 0 0-.408-.05 6.5 6.5 0 0 0-3.033 1.892A5.17 5.17 0 0 0 10 5.9\"></path></g><defs><clipPath id=\"book-flip-page_svg__a\"><path fill=\"#fff\" d=\"M0 .5h20v20H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }